import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'

/** Match HeaderRoutingApp title (24 / 32) — both crumb segments same size. */
const CRUMB_FONT_SIZE = 24
const CRUMB_LINE_HEIGHT = '32px'

export const useStyles = makeStyles()(() => ({
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    // Fill header title slot and ellipsize long names on one line.
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    fontFamily: fundingFont,
    fontSize: CRUMB_FONT_SIZE,
    lineHeight: CRUMB_LINE_HEIGHT,
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  link: {
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
    color: C.mutedText,
    '&:hover': { textDecoration: 'underline', color: C.darkText },
  },
  separator: {
    fontSize: 14,
    width: 14,
    height: 14,
    color: C.mutedText,
    flexShrink: 0,
  },
  current: {
    display: 'block',
    minWidth: 0,
    flex: '1 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
    color: C.strongText,
  },
}))
